import ContactModal from './ContactModal';

// Doing a default export here so we can use a short path in the `ContactService` lazy load
export default ContactModal;
